<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <!-- <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="200"
        ></v-img>-->
        <v-img
          alt="DigiPoS"
          :src="require('@/assets/digitory/Light_Transparent.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-flex>

      <v-flex mb-4>
        <!-- <h1 class="display-1 font-weight-light mb-3 text-uppercase">Welcome to Rolo KDS</h1> -->
        <h2 class="subheading grey--text">
          No orders available, please wait
          <v-icon color="orange">directions_walk</v-icon>
          <v-icon color="red">directions_run</v-icon>
        </h2>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style>
</style>
